


































































































    import { Component, Vue,Watch } from 'vue-property-decorator';
    import { mapState } from 'vuex';
    import { store, StoreState, isElectron, Timezone } from '../store';
    import FilterContainer from '../components/call-reports/FilterContainer.vue';
    import ScheduleContainer from '../components/call-reports/ScheduleContainer.vue';
    import DisplayContainer from '../components/call-reports/DisplayContainer.vue';
    import Sidebar from "../components/Sidebar.vue";
    import momentTZ from 'moment-timezone';
    import drag from '@branu-jp/v-drag';  
    import 'moment-duration-format';
    import * as moment from 'moment';
    import axios from  'axios';
    import VueElementLoading from 'vue-element-loading';
    

    import Search from "../components/call-reports/display-container/Search.vue";


    @Component({
        components: {
            FilterContainer,
            ScheduleContainer,
            DisplayContainer,
            Sidebar,Search  ,VueElementLoading
        },

        mounted:function()
        {
            //this.$store.commit("CLEAR_CALLREPORTS");  
            this.$store.commit('UPDATE_CALL_REPORTS', {clear:true,});
            //this.$store.dispatch('getExtensions');   
        },
        computed: {
            ...mapState({
                'jwt': (state: StoreState) => state.account.jwt,
                showReplaceModal: (state: StoreState) => state.reports.showReplaceModal,
                showDeleteModal: (state: StoreState) => state.reports.showDeleteModal,
                replaceFilename: (state: StoreState) => state.reports.replaceFilename,
                'timezone': (state: StoreState) => state.reports.filters.timezone,
                sliderstatus: (state: StoreState) => state.reports.callreport_Slide,
            })
        },
        directives: {
            drag
        },
         beforeDestroy() {
           ////Befor destroy clear date values
            this.$store.commit('SET_START_DATE',  null );
            this.$store.commit('SET_END_DATE',  null);   
        }
         
    })
    export default class CallReports extends Vue {

        showReplaceReportModal: boolean = false;
        showReplaceDeleteModal: boolean = false;
        replaceFilename!: string;
        timezone!: Timezone;
	    public jwt!: string;
        data() {
            return {
                 draggable: true,
                drawerVisible: true,
                delete_id: null,
                delete_rev: null,
                show_modal: false,
                title: '',
                playing: false,
                src_url: '/',
                progress: 0,
                show_delete_modal: false,
                duration: 0,
                current_time: 0,
                display:false,
                tabstatus:true,
                selectedColor: true,
                selecteback:'',
                playnext_No:0,
                record_statusMsg:false,
                record_loading:false,
                sample_media:[
                            { media: "media1", Id: 1,time:'01:00',src_url1:'https://s3-us-west-2.amazonaws.com/spokerecordings/173d9d1269761052da83512b3e47fbe7/call_recording_88437NjRkYjRiZmI2NmYxNWEyOGYyZTRmZjA0OGE5OGViZTA.mp3' },
                            { media: "media2", Id: 2 ,time:'03:10',src_url1:'https://s3-us-west-2.amazonaws.com/spokerecordings/173d9d1269761052da83512b3e47fbe7/call_recording_88437ZDllNWJhYmJhNzMzZDYyNjZiYjM5ZDdiN2U4N2E2Yzc.mp3'},
                            { media: "media3", Id: 3,time:'11:00' ,src_url1:'https://s3-us-west-2.amazonaws.com/spokerecordings/173d9d1269761052da83512b3e47fbe7/call_recording_0_4178651715@10.10.24.52.mp3'},
                            { media: "media4", Id: 4,time:'00:20',src_url1:'https://s3-us-west-2.amazonaws.com/spokerecordings/173d9d1269761052da83512b3e47fbe7/call_recording_0_3853060043@10.10.24.52.mp3'}
                    ],

               
            };
        }

        created() {
          
            const url = window.location.href;
            const re = /\?(.+)/;
            const matches = re.exec(url);
            if(matches && matches.length > 0 && matches[1].includes("open=true")) {
                this.$data.drawerVisible = true;
            }
          //  this.$store.dispatch('getExtensions');   
        }
     
        SCHEDULEenableTAb(){
            this.$data.tabstatus=false;//'blue';
        }
        RUNenableTAb(){
            this.$data.tabstatus=true;
        }
      
        shouldCloseDrawer() {
            this.$data.drawerVisible = false;
        }

        deleteReport(e) {
            const { id, rev } = e;
            this.$data.delete_id = id;
            this.$data.delete_rev = rev;
            this.$store.commit("SHOW_DELETE_MODAL");
        }

        isElectron() {
            return isElectron();
        }
        
        get formattedDuration() {
            const tot_secs = Math.floor(parseInt(this.$data.duration));
            const min = Math.floor(tot_secs / 60);
            const sec = tot_secs % 60;
            const secString = (sec.toString() as any).padStart(2, '0');
            return `${min.toString()}:${secString}`;
        }

        get formattedCurrentTime() {
            const tot_secs = Math.floor(parseInt(this.$data.current_time));
            const min = Math.floor(tot_secs / 60);
            const sec = tot_secs % 60;
            const secString = (sec.toString() as any).padStart(2, '0');
            return `${min.toString()}:${secString}`;
        }
           
        closeModal() {
            this.$data.playing = false;
            this.$data.display=false;
            this.$data.show_modal = false;
            this.pauseRecording();
        }

       playCallRecording(payload) {
              this.$data.selecteback='';
            //this.$data.sample_media=payload.call_recording_medias;
            this.$data.show_modal = true;
            this.$data.src_url = payload.call_recording;
            this.$data.display=false;
          //  this.$data.src_url =null;
          
            this.$data.title =payload.timestamp;;// momentTZ(momentTZ(payload.timestamp, 'x').format()).tz(this.timezone.tz).format('Y-MM-DD h:mm a');//title;
            // var self=this;
            // setTimeout(function(){ 
            //        // alert("Hello");
            //        self.check_AccessRecord();
            //         //alert(self.$data.record_statusMsg )
            //        // alert( self.$data.show_modal )
            //      }, 
            //     3000);
            this.$nextTick(function() {
                const windowH = window.innerHeight;
                const windowW = window.innerWidth;
                const scrollX = window.scrollX;
                const scrollY = window.scrollY;
                const modalH = (this.$refs.modal as any).clientHeight;
                const modalW = (this.$refs.modal as any).clientWidth;
                (this.$refs.modal as any).style.top = `${windowH/2 - modalH/2 + scrollY}px`;
                (this.$refs.modal as any).style.left = `${windowW/2 - modalW/2 + scrollX}px`;
            });
        }


       //check access Access Denied
        check_AccessRecord(){
         axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.jwt;
            return axios.get(`${this.$data.src_url}`)
            .then(response => { 
                alert('response')
                    console.log(response)
                    this.$data.record_statusMsg=false; 
                    this.$data.record_loading=false;
                    this.$data.show_modal = true;
                     return response;
                })
                .catch(error => {
                    alert('error')
                    console.log(error)
                    this.$data.record_loading=false;
                    this.$data.record_statusMsg=true;  
                    this.$data.show_modal = false; 
                    return error;
                }); 
                
        } 



        playnext()
        {
            this.$data.playing = false;
            // this.$data.playnext_No =1 + this.$data.playnext_No;
            // for(var i=0; i<this.$data.sample_media.length; i++)
            // {
            //     if(this.$data.playnext_No==this.$data.sample_media[i].Id)
            //     {
            //          this.$data.selecteback=this.$data.sample_media[i].Id;
            //          this.$data.src_url=this.$data. sample_media[i].src_url1;
            //         this.playRecording();
            //     }
            // }
        }

         playCallRecording1(payload) {
            this.$data.show_modal = true;
            this.$data.display=false; 
            this.$data.src_url =payload.src_url1;
            this.playRecording();
            this.$data.selecteback=this.$data.playnext_No=payload.Id;
            this.$nextTick(function() {
                const windowH = window.innerHeight;
                const windowW = window.innerWidth;
                const scrollX = window.scrollX;
                const scrollY = window.scrollY;
                const modalH = (this.$refs.modal as any).clientHeight;
                const modalW = (this.$refs.modal as any).clientWidth;
                (this.$refs.modal as any).style.top = `${windowH/2 - modalH/2 + scrollY}px`;
                (this.$refs.modal as any).style.left = `${windowW/2 - modalW/2 + scrollX}px`;
            });
        }

        playRecording() {
            this.$data.playing = true;
            (this.$refs.audio as HTMLAudioElement).play();
        }

        pauseRecording() {
            this.$data.playing = false;
            (this.$refs.audio as HTMLAudioElement).pause();
        }

        updateDuration() {
            if (this.$refs.audio) {
                this.$data.duration = (this.$refs.audio as HTMLAudioElement).duration;
            }
        }

        canplayaudio()
        {
            if (this.$refs.audio) {
                this.playRecording() ;
               this.$data.display=true;;
            }
        }

        updateCurrentRecordingTime(event) {
            this.$data.current_time = (this.$refs.audio as HTMLAudioElement).currentTime;
            this.$data.progress = Math.floor((this.$data.current_time/this.$data.duration)*100);
        }

          grabbedScrubber(event) {
            this.$data.draggable = false;
            this.$data.initalDragX = event.clientX;
            this.pauseRecording();
            
            document.addEventListener('mousemove', this.mouseMoveListener);
            document.addEventListener('mouseup', this.mouseUpListener);
        }

        mouseMoveListener(e: any) {
            const scrubberWidth = (this.$refs.scrubber as any).clientWidth;
            const scrubberRects = (this.$refs.scrubber as any).getClientRects()[0];
            const relPosition = Math.floor(e.clientX - scrubberRects.left);
            if (relPosition <= 0) {
                this.$data.progress = 0;
            } else if(relPosition >= scrubberWidth) {
                this.$data.progress = 100;
            } else {
                this.$data.progress = Math.floor((relPosition/scrubberWidth)*100);
            }
            this.$data.current_time = (this.$data.duration*(this.$data.progress/100));
        }

        mouseUpListener() {
            (this.$refs.audio as HTMLAudioElement).currentTime = (this.$data.duration*(this.$data.progress/100));
            document.removeEventListener('mouseup', this.mouseUpListener);
            document.removeEventListener('mousemove', this.mouseMoveListener);
            this.playRecording();
        }
         Showloader(){  
             var slider=(this as any).sliderstatus;
             slider=!slider;
           // this.$store.commit("CALLREPORT_SLIDER", slider);
        }

        get ramdom(){
            // Math.pow is slow, use constant instead.
        var color = Math.floor(Math.random() * 16777216).toString(16);
        // Avoid loops.
        return '#000000'.slice(0, -color.length) + color;
        }
    }

